import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

import { logout } from "../../store/actions";
import { useSession } from "../Hooks/UserHooks";
import avatar from "../../assets/images/users/user-dummy-img.jpg";
import { SigninResponse, State, UserProfileDto } from "../../interfaces";
import { getShortenName } from "../../services";
import { MediaDto } from "../../interfaces/media";

export const ProfileDropdown = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { session } = useSession();
  const { t, i18n } = useTranslation();

  const { response: user } = useSelector(
    (state: any): State<UserProfileDto> => state.account.userProfile
  );

  const { response: updatedProfilePhoto } = useSelector(
    (state: any): State<MediaDto> => state.account.userProfileImage
  );

  const { success, loading } = useSelector(
    (state: any): State<any> => state.auth.logout
  );

  //Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  const signout = () => {
    if (session && session.refreshToken) {
      dispatch(
        logout(
          { refreshToken: (session as SigninResponse)?.refreshToken },
          history
        )
      );
    }
  };

  useEffect(() => {
    if (!loading && success === true) {
      localStorage.removeItem("session");
      history.replace("/login");
    }
  }, [loading]);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item topbar-user"
      >
        <DropdownToggle tag="button" type="button" className="btn">
          <span className="d-flex align-items-center ">
            <img
              className="rounded-circle header-profile-user"
              src={updatedProfilePhoto?.path || user?.profilePhoto || avatar}
              alt="Header Avatar"
            />
            <span className="text-start ms-xl-2">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                {i18n.language === "ar"
                  ? getShortenName(user?.name.ar)
                  : getShortenName(user?.name.en)}
              </span>
              <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                {i18n.language === "ar"
                  ? user?.role?.name?.ar
                  : user?.role?.name?.en}
              </span>
            </span>
          </span>
        </DropdownToggle>
        <DropdownMenu
          className="dropdown-menu-end"
          style={{ textAlign: "initial" }}
        >
          <h6 className="dropdown-header">
            {t("welcome")}{" "}
            {i18n.language === "ar"
              ? getShortenName(user?.name.ar)
              : getShortenName(user?.name.en)}
            !
          </h6>
          <Link to="/settings">
            <DropdownItem style={{ textAlign: "initial" }}>
              <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle">{t("settings")}</span>
            </DropdownItem>
          </Link>
          <DropdownItem onClick={signout} style={{ textAlign: "initial" }}>
            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle" data-key="t-logout">
              {t("signout")}
            </span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};
